import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectNotification } from "../store/wizard/wizardSlice";

export const useNotification = () => {
  const notificationData = useSelector(selectNotification);

  return useMemo(() => notificationData, [notificationData]);
};
